module.exports = __webpack_public_path__ + "img/Grupo 320.164f5d74.svg";